import type { Locale, LocaleCatalog, LocaleKey } from './types';
import { enUS } from './locales/en-US';
import { zhCN } from './locales/zh-CN';
import { zhTW } from './locales/zh-TW';

export type MissingTranslationEvent = Readonly<{
  locale: Locale;
  key: string;
  fallback: 'en-US' | 'generic';
}>;

let missingTranslationEvents: readonly MissingTranslationEvent[] = [];

export const catalogs: Readonly<Record<Locale, LocaleCatalog>> = {
  'zh-CN': zhCN,
  'zh-TW': zhTW,
  'en-US': enUS,
};

export function getMissingTranslationEvents(): readonly MissingTranslationEvent[] {
  return missingTranslationEvents;
}

export function clearMissingTranslationEvents(): void {
  missingTranslationEvents = [];
}

export function translate(locale: Locale, key: LocaleKey, values?: Readonly<Record<string, string | number>>): string {
  const current = catalogs[locale]?.[key];
  const fallback = catalogs['en-US']?.[key];
  const template = current ?? fallback ?? 'Translation unavailable';
  if (!current) {
    missingTranslationEvents = [...missingTranslationEvents, {
      locale,
      key: String(key),
      fallback: fallback ? 'en-US' : 'generic',
    }];
  }
  return template.replace(/\{(\w+)\}/g, (_match, name: string) => String(values?.[name] ?? `{${name}}`));
}
